import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { baseurly } from '../../utils/apis.ts';
import { X_API_KEY } from '../../utils/apis.ts';
import { baseurl } from '../../utils/apis.ts';
import PdfDocumentLayout from '../../components/PdfDocumentLayout.tsx';

interface ProcessDocument {
  id: number;
  file: string;
  title: string;
  building_id: {
    Int64: number;
    Valid: boolean;
  };
  vehicle_model_id: {
    Int64: number;
    Valid: boolean;
  };
}

const ProcessDocumentPage: React.FC = () => {
  const { docId } = useParams();
  const [processDoc, setProcessDoc] = useState<ProcessDocument | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (docId) {
      fetch(`${baseurly}/process_docs/${docId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'X-API-KEY': X_API_KEY,
        },
        credentials: "include",
      })
        .then((res) => {
          if (!res.ok) {
            throw new Error('Failed to fetch process document');
          }
          return res.json();
        })
        .then((data) => {
          setProcessDoc(data);
          setLoading(false);
        })
        .catch((err) => {
          console.error('Error fetching process document:', err);
          setError('Unable to load process document');
          setLoading(false);
        });
    }
  }, [docId]);

  // If the file property is relative, prepend the base URL.
  const fileUrl =
    processDoc && processDoc.file
      ? processDoc.file.startsWith('http')
        ? processDoc.file
        : `${baseurl}files/${processDoc.file}`
      : '';

  if (loading) {
    return (
      <div className="min-h-screen bg-blue-900 p-6">
        <div className="text-white text-center mt-20">Loading...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-blue-900 p-6">
        <div className="text-white text-center mt-20">{error}</div>
      </div>
    );
  }

  return (
    <PdfDocumentLayout
      title={processDoc?.title}
      fallbackTitle="Process Document"
      fileUrl={fileUrl}
      hasDocument={Boolean(processDoc && processDoc.file)}
      emptyMessage="No process document found for this building."
    />
  );
};

export default ProcessDocumentPage;
